<template>
  <div class="flex flex-col text-left text-textPrimary">
    <div class="flex items-center gap-3 mb-2">
      <div
        class="flex items-center bg-gray-50 rounded-lg border border-gray-100 p-1 pr-3 shadow-sm"
      >
        <div
          class="flex flex-col px-2"
          :class="{ 'border-r border-gray-200 mr-2': hasDoctorStation }"
        >
          <span class="text-[10px] text-gray-400 uppercase font-bold leading-none">Estação</span>
          <span class="text-sm font-medium text-gray-500 leading-tight"
            >#{{ stationDetails?.id }}</span
          >
        </div>

        <template v-if="hasDoctorStation">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400 mx-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>

          <div class="flex items-center">
            <span class="text-base md:text-xl font-bold text-gray-700 leading-tight"
              >#{{ stationDetails?.doctorStation?.id }}</span
            >
          </div>
        </template>
      </div>

      <span class="font-bold text-lg md:text-2xl">{{ title }}</span>
    </div>

    <span class="text-xs md:text-base text-primary40 flex items-center gap-1 flex-wrap">
      {{ stationDetails?.schedule?.healthUnit?.company?.name || 'Company' }}
      <span class="text-gray-300 text-xs mx-1">›</span>
      {{ stationDetails?.schedule?.healthUnit?.name || 'Health Unit' }}
      <span class="text-gray-300 text-xs mx-1">›</span>
      {{ stationDetails?.schedule?.name || 'Schedule' }}
      <span class="text-gray-300 text-xs mx-1">›</span>
      {{ stationDetails?.position?.name || 'Position not defined' }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue'
import { ShiftDetails } from '@/Network/Types/Responses/StationResponses'

const props = defineProps({
  stationDetails: {
    type: Object as PropType<ShiftDetails | null>,
    default: () => null
  },
  title: {
    type: String,
    required: true
  }
})

// Helper para verificar se existe o ID do vínculo médico
const hasDoctorStation = computed(() => {
  return !!props.stationDetails?.doctorStation?.id
})
</script>
